<form>
  <div class="ps-large-y">
    <h2>{{ 'MMB.apis.form.countryOfResidence.title' | finLocalization }}</h2>
  </div>

  <div class="ps-small-b font-body-1 nordic-blue-900-text align-right">
    {{ 'MMB.apis.form.passport.mandatoryFields' | finLocalization }}
  </div>

  <div class="flex flex--wrap ps-large-b">
    <fin-select-input
      class="flex-1 input-field"
      [translationPrefix]="'MMB.apis.form.country'"
      [parentForm]="countryOfResidenceForm"
      [controlName]="'countryOfResidence'"
      [options]="countries$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>
  </div>

  <div role="presentation" class="border-top-dashed nordic-blue-100-border fill"></div>

  <div class="ps-large-y flex flex--end">
    <fcom-button
      [type]="ButtonType.SUBMIT"
      [loading]="loading"
      (clickBtn)="saveAndContinue()"
      [text]="'MMB.apis.form.buttons.confirmSave' | finLocalization"
    ></fcom-button>
  </div>
</form>
